'use client'

import { useEffect, useState } from 'react'
import { fetchCategoriesApi } from '@/lib/commerce/services/product-api'
import { findCategoryById, getCategoryDescendantIds } from '@/utils/product'

export function useCategoryExpander(vendorId: string, initialIds: string[]) {
  const [expandedIds, setExpandedIds] = useState<string>(initialIds.join(','))
  const [loaded, setLoaded] = useState(false)

  const key = initialIds.join(',')

  useEffect(() => {
    let cancelled = false
    const run = async () => {
      try {
        const result = await fetchCategoriesApi(vendorId)
        if (cancelled) return
        if (result?.status === 200 && result.data) {
          const expanded = initialIds.flatMap(id => {
            const found = findCategoryById(result.data, id)
            return found ? getCategoryDescendantIds(found) : [id]
          })
          setExpandedIds(Array.from(new Set(expanded)).join(','))
        }
      } catch (err) {
        console.error('Error fetching categories:', err)
      } finally {
        if (!cancelled) setLoaded(true)
      }
    }
    run()
    return () => { cancelled = true }
  }, [vendorId, key])

  return { expandedIds, loaded }
}
